<template>
  <b-container class="card-container">
    <b-card no-body>
      <template v-slot:header>

        <b-button size="sm" variant="primary float-right" :to="{name: `${collection}_create`}">Create</b-button>
      </template>

      <b-table show-empty :items="items" @row-clicked="view_row" hover class="clickable" :fields="['name', 'status', 'from', 'total', 'created']">
        <template v-slot:cell(created)='data'>
          {{data.value | date}}
        </template>
        <template v-slot:cell(from)='data'>
          <span v-if='data.item.sender && data.item.sender.email'>{{data.item.sender.email}}</span>
        </template>
        <!-- <template v-slot:cell(name)='data'>
          <b-link :to="{name: collection, params: {id: data.item.id}}">{{data.value}}</b-link>
        </template> -->
      </b-table>
    </b-card>
  </b-container>
</template>

<script>

import { db } from '@/main.js'
import ItemMixin from '@/mixins/Item.js'
import constants from '@/lib/constants.js'

export default {
  metaInfo: {title: 'Sequences'},
  mixins: [ItemMixin],
  firestore: function () {
    let items = db.collection(this.collection).where('user', '==', db.collection('user').doc(this.profile.id))
    if (this.profile.team_role.role === constants.team_role.admin || this.profile.team_role.role === constants.team_role.manager) {
      items = db.collection(this.collection).where('team', '==', db.collection('team').doc(this.profile.team.id))
    }

    if (this.profile.role === 'admin') {
      items = db.collection(this.collection)
    }

    return {
      items: items.orderBy('created', 'desc')
    }
  },
  data() {
    return {
      collection: 'sequence'
    }
  },
  methods: {

  },
}
</script>

<style scoped>

</style>
